import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { InteriorSlide, SlideHeader, SlideBanner } from './SlideShell';
import type { SlideProps } from './SlideShell';
export function Slide07Scope({
  index
}: SlideProps) {
  const inclusions = ['Annual campaign strategy built around brand and country objectives', '4 Snak campaigns per year (quiz-based, mobile-first, data-driven)', 'Real-time performance monitoring & automated alerts', 'Bi-monthly reporting — you get insights, not spreadsheets', 'Adaptation and Localization* for additional countries at €900 per country'];
  return <InteriorSlide banner={<SlideBanner stat={<div className="text-4xl font-extrabold text-white" data-id="element-150">4</div>} data-id="element-149">
          campaigns included per year, per brand
        </SlideBanner>} data-id="element-148">
      <SlideHeader eyebrow="Annual Partnership" data-id="element-151">
        What's Included Per Brand
      </SlideHeader>

      <div className="flex-1 flex flex-col lg:flex-row items-center gap-12 lg:gap-16 max-w-6xl mx-auto w-full" data-id="element-152">
        {/* Left: Content */}
        <div className="flex-1 space-y-6 w-full" data-id="element-153">
          <div className="bg-white rounded-3xl shadow-sm border border-black/5 p-8 md:p-10" data-id="element-154">
            <div className="space-y-6" data-id="element-155">
              {inclusions.map((item, i) => <motion.div key={i} initial={{
              opacity: 0,
              x: -20
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              delay: 0.3 + i * 0.1,
              duration: 0.5
            }} className="flex items-start gap-4 group" data-id="element-156">
                  <div className="mt-1 h-6 w-6 rounded-full bg-[var(--surface)] flex items-center justify-center flex-shrink-0 group-hover:bg-[var(--brand)] transition-colors" data-id="element-157">
                    <CheckCircle2 className="h-4 w-4 text-[var(--brand)] group-hover:text-white transition-colors" data-id="element-158" />
                  </div>
                  <p className="text-[clamp(1.1rem,1.3vw,1.2rem)] text-[var(--fg)] font-medium leading-relaxed" data-id="element-159">
                    {item}
                  </p>
                </motion.div>)}
            </div>

            <motion.p initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            delay: 0.9
          }} className="mt-8 text-sm text-[var(--muted)] italic" data-id="element-160">
              *first new language charged separately at €500 per language
            </motion.p>
          </div>
        </div>

        {/* Right: Visual */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.4,
        duration: 0.8
      }} className="flex-1 w-full relative aspect-[4/5] max-w-md rounded-3xl overflow-hidden shadow-2xl border-8 border-white" data-id="element-161">
          <img src="https://images.unsplash.com/photo-1584516150909-c43483ee7932?w=1200&q=80" alt="African medical team collaborating" className="w-full h-full object-cover" data-id="element-162" />
          <div className="absolute inset-0 bg-gradient-to-t from-[var(--brand)]/60 via-transparent to-transparent mix-blend-multiply" data-id="element-163" />
        </motion.div>
      </div>
    </InteriorSlide>;
}